const envDealerOrderEditTimeLimit = Number(import.meta.env.VITE_APP_dealerOrderEditTimeLimit);

// The maximum time the dealer is given to edit the order since it was created.
// Overridable per environment via VITE_APP_dealerOrderEditTimeLimit (e.g. to match a raised UAT limit).
export const dealerOrderEditTimeLimit =
  Number.isFinite(envDealerOrderEditTimeLimit) && envDealerOrderEditTimeLimit > 0 ? envDealerOrderEditTimeLimit : 30;

// Number of remaining minutes where we show the order edit warning to the user.
export const dealerOrderEditWarningTimeLimit = 5;
